<template>
  <div class="studio-product-content">
    <div class="row mt-5">
      <div
        v-for="media in sortedPlaylistContent"
        :key="media.id"
        class="column col-6 col-md-4 col-lg-3 mt-2"
      >
        <router-link
          class="undecorated-router-link"
          :to="
            getCorrectRoute({
              playlist_id: playlist.id,
              media_id: media.id,
              isMediaLocked: media.media.locked,
            })
          "
        >
          <StudioMediaCard :product="product" :media="media" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import StudioMediaCard from '@/web/components/products/StudioMediaCard';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'StudioPlaylistContent',
  components: {
    StudioMediaCard,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  props: {
    review: {
      type: Boolean,
      default: false,
    },
    playlist: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    sortedPlaylistContent() {
      return [...this.playlist.content].sort((a, b) => a.position - b.position);
    },
  },
  methods: {
    getCorrectRoute({ playlist_id, media_id, isMediaLocked }) {
      if (isMediaLocked) {
        return {
          name: 'studio-product-checkout',
          params: { product_id: this.$route.params.product_id },
        };
      }
      return {
        name: 'studio-playlist-media',
        params: { playlist_id, media_id },
      };
    },
  },
});
</script>

<style scoped>
.review {
  pointer-events: none;
}
</style>
